<button type="button" class="reset-filter" [disabled]="disabled()" data-testid="reset-filter" (click)="onClick()">
  <svg class="reset-filter__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" d="M6 6l12 12M18 6L6 18" />
  </svg>
  <span>{{ label() }}</span>
</button>
